import settings from '@/settings'

const pegarPorAssinatura = (headers, payload) => {
  let url = `${settings.apetrusApi}/veiculos/assinatura/`
  if (payload) {
    const keys = Object.keys(payload)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload[keys[i]]}`
    }
  }
  return fetch(
    url,
    {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      cache: 'no-cache'
    }
  )
}

export default {
  pegarPorAssinatura
}
